import { createContext, useContext, useState, useEffect } from "react";

const LangContext = createContext({ lang: "pl", toggle: () => {} });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const fromUrl = new URLSearchParams(window.location.search).get("lang");
    if (fromUrl === "en" || fromUrl === "pl") return fromUrl;
    return localStorage.getItem("lang") || "pl";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem("lang", lang);

    const params = new URLSearchParams(window.location.search);
    if (lang === "en") params.set("lang", "en");
    else params.delete("lang");
    const qs = params.toString();
    const next = `${window.location.pathname}${qs ? `?${qs}` : ""}${window.location.hash}`;
    if (`${window.location.pathname}${window.location.search}${window.location.hash}` !== next) {
      window.history.replaceState(null, "", next);
    }
  }, [lang]);

  const toggle = () => setLang((l) => (l === "pl" ? "en" : "pl"));

  return (
    <LangContext.Provider value={{ lang, toggle }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
